<app-modal-container>
  <span class="modal-header-content">
    {{ 'label_comment_deletion_header' | translate }}
  </span>

  <div class="modal-body-content d-flex flex-column">
    <div class="row margin-top-xs">
      <div class="col-md-12">
        {{ 'label_comment_deletion_confirmation' | translate }}
      </div>
    </div>

    <div class="row margin-top-md">
      <div class="col-md-12 d-flex flex-column" id="comment-preview">
        <div class="d-flex gap-2 align-items-center">
          <span class="fw-bold">
            {{ 'added_comment' | translate }}
          </span>
          @if (comment[$manualAuditIssueComment.internal]) {
            <ds-chip [text]="'internal' | translate" [colorVariant]="DsChipColorVariant.Gray"></ds-chip>
          }
        </div>
        <span>{{ userAndTimestamp }}</span>
        <span class="margin-top">{{ comment[$manualAuditIssueComment.message] }}</span>
      </div>
    </div>
  </div>

  <div class="modal-footer-content">
    <div class="row">
      <div class="col-md-12 d-flex justify-content-end">
        <button class="btn btn-outline-primary" (click)="close()">
          {{ 'label_close' | translate }}
        </button>
        <button class="btn btn-primary margin-left" (click)="onCommentDelete()">
          {{ 'action_delete' | translate }}
        </button>
      </div>
    </div>
  </div>
</app-modal-container>
